import { render, staticRenderFns } from "./Choferes.vue?vue&type=template&id=70490aab&scoped=true"
import script from "./Choferes.vue?vue&type=script&lang=js"
export * from "./Choferes.vue?vue&type=script&lang=js"
import style0 from "./Choferes.vue?vue&type=style&index=0&id=70490aab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70490aab",
  null
  
)

export default component.exports